import { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Table, Button, message, Row, Col } from "antd";
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import ModalSeleccionarExamenEditar from "./ModalSeleccionarExamenEditar";
import { actualizarPromocion } from "../../../Service/Service.promocion";

const PromocionEditarModal = ({ data, visible, handleClose, onSave }) => {
    const [form] = Form.useForm();
    const [examenes, setExamenes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalSeleccionExamen, setModalSeleccionExamen] = useState(false);

    useEffect(() => {
        if (visible && data) {
            form.setFieldsValue({
                nombre: data.nombre,
                seguro_id: data.seguro_id,
            });
            setExamenes(data.detalles || []);
        }
    }, [visible, data]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            
            const payload = {
                id_promocion: data.id_promocion,
                cabecera: {
                    nombre: values.nombre,
                    seguro_id: values.seguro_id
                },
                detalle: examenes
                    .filter(ex => (ex.tarifario?.idprocedimiento_company_precios || ex.idprocedimiento_company_precios))
                    .map(ex => ({
                        id_tipo_examen: ex.id_tipo_examen,
                        precio_promocion: ex.precio_promocion,
                        idprocedimiento_company_precios: ex.tarifario?.idprocedimiento_company_precios || ex.idprocedimiento_company_precios
                    }))
            };
    
            setLoading(true);
    
            const response = await actualizarPromocion(payload);
    
            if (response.success) {
                message.success("Promoción actualizada correctamente.");
                handleClose();
                if (onSave) {
                    onSave(); // 🔥🔥🔥 Llamar onSave para actualizar ventana
                }
            } else {
                throw new Error(response.message || "Error al actualizar promoción");
            }
            
        } catch (error) {
            console.error(error);
            message.error(error.message || "Error inesperado");
        } finally {
            setLoading(false);
        }
    };
    

    const eliminarExamen = (id) => {
        setExamenes(examenes.filter(ex => ex.id_tipo_examen !== id));
    };

    const actualizarPrecio = (id, nuevoPrecio) => {
        setExamenes(examenes.map(ex =>
            ex.id_tipo_examen === id ? { ...ex, precio_promocion: nuevoPrecio } : ex
        ));
    };

    const agregarExamenesSeleccionados = (nuevosExamenes) => {
        setExamenes(prev => [...prev, ...nuevosExamenes]);
    };

    const columns = [
        {
            title: "Código",
            dataIndex: ["ExamenTipo", "codigo"],
            key: "codigo",
            width: 100,
        },
        {
            title: "Descripción",
            dataIndex: ["ExamenTipo", "descripcion"],
            key: "descripcion",
            width: 200,
        },
        {
            title: "Precio Normal",
            dataIndex: ["tarifario", "precio"],
            key: "precio_normal",
            render: (text) => `$${parseFloat(text).toFixed(2)}`,
            width: 120,
        },
        {
            title: "Precio Promoción",
            dataIndex: "precio_promocion",
            key: "precio_promocion",
            render: (text, record) => (
                <Input
                    type="number"
                    min="0"
                    step="0.01"
                    value={text}
                    onChange={(e) => actualizarPrecio(record.id_tipo_examen, parseFloat(e.target.value) || 0)}
                />
            ),
            width: 150,
        },
        {
            title: "Acción",
            key: "action",
            render: (_, record) => (
                <Button
                    danger
                    icon={<MinusOutlined />}
                    onClick={() => eliminarExamen(record.id_tipo_examen)}
                />
            ),
            width: 80,
        },
    ];

    return (
        <>
            <Modal
                title="Editar Promoción"
                open={visible}
                onOk={handleSave}
                onCancel={handleClose}
                width={900}
                confirmLoading={loading}
                destroyOnClose
            >
                <Form form={form} layout="vertical">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="nombre" label="Nombre de la Promoción">
                                <Input disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="seguro_id" label="Seguro/Entidad">
                                <Select disabled>
                                    <Select.Option value={1}>PARTICULAR</Select.Option>
                                    <Select.Option value={2}>SEGURO A</Select.Option>
                                    <Select.Option value={3}>SEGURO B</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                <div style={{ margin: '16px 0' }}>
                    <Button type="dashed" icon={<PlusOutlined />} onClick={() => setModalSeleccionExamen(true)}>
                        Agregar Examen
                    </Button>
                </div>

                <Table
                    dataSource={examenes}
                    columns={columns}
                    rowKey="id_tipo_examen"
                    pagination={false}
                    scroll={{ y: 240 }}
                    bordered
                />
            </Modal>

            {/* Modal seleccionar examen */}
            <ModalSeleccionarExamenEditar
                show={modalSeleccionExamen}
                handleClose={() => setModalSeleccionExamen(false)}
                agregarExamenes={agregarExamenesSeleccionados}
                seguroId={form.getFieldValue("seguro_id")}
                examenesActuales={examenes}
            />
        </>
    );
};

export default PromocionEditarModal;
